import { render, staticRenderFns } from "./wxzhlist.vue?vue&type=template&id=3f8fd9a0&scoped=true&"
import script from "./wxzhlist.vue?vue&type=script&lang=js&"
export * from "./wxzhlist.vue?vue&type=script&lang=js&"
import style0 from "./wxzhlist.vue?vue&type=style&index=0&id=3f8fd9a0&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8fd9a0",
  null
  
)

export default component.exports